import type {AuthState} from "@frontegg/redux-store";
import {environment} from "../../env";
import type {NavigationIntent} from "../AuthContext";

/**
 * Make sure that all redirectCallbacks are registered as valid URLS in the Frontegg dashboard
 *
 * @see https://portal.frontegg.com/development/authentication/hosted
 *
 * @param frontEggContext
 * @param redirectCallback
 */
export function onFronteggLogout(
    frontEggContext: AuthState,
    redirectCallback: NavigationIntent,
) {
    const target = `${window.location.origin}${redirectCallback.route}`
    const logoutLink = `${environment.frontEggBaseUrl}/oauth/logout?post_logout_redirect_uri=${target}`;
    console.debug('FrontEggLogout: Logging out', logoutLink);
    window.location.href = logoutLink;
}
